<template>
    <div class="contnedor_calendario">
        <!-- Cabecera: Mes y flechas -->
        <div class="picker-header">
            <button type="button" @click="previousWeek()">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="picker-header-arrow"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="2"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M15 19l-7-7 7-7"
                    />
                </svg>
            </button>

            <h2>
                {{ calculateMes() }}
            </h2>
            <button type="button" @click="nextWeek()">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="picker-header-arrow"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="2"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M9 5l7 7-7 7"
                    />
                </svg>
            </button>
        </div>

        <div
            class="calendario"
            :style="`grid-template-columns: ${
                num_dias == 1 ? '50' : '9'
            }% repeat(${show_dias}, ${
                (100 - (num_dias == 1 ? 50 : 9)) / show_dias
            }% [col-start])`"
        >
            <!-- Cabecera: Dias de la semana -->
            <div style="border-bottom: 1px solid rgb(216, 216, 216)"></div>
            <div class="dias" v-for="(dia, index) in semana" :key="index">
                <div
                    class="titulo"
                    style="border-bottom: 1px solid rgb(216, 216, 216)"
                >
                    <div class="dia">
                        {{ dias[dia.label] }}
                    </div>
                    <div class="dia amountButton-0">
                        {{ dia.date.split("-")[2] }}
                    </div>
                </div>
            </div>

            <template v-for="(equipo, index) in equipos">
                <div class="time date-container" style="padding: 10px">
                    {{ equipo.nombre }}
                </div>
                <template v-for="(dia, index) in semana">
                    <div class="cita date-container">
                        <template v-for="(elemento, index) in value">
                            <!-- Forma nueva con la relacion de varias ordenes -->
                            <template v-if="elemento.ordenes_trabajo != null">
                                <template
                                    v-for="(
                                        orden, index2
                                    ) in elemento.ordenes_trabajo"
                                >
                                    <router-link
                                        v-if="
                                            isElementoVisible(
                                                elemento,
                                                dia,
                                                equipo
                                            )
                                        "
                                        :to="{
                                            path: `/guardar-orden?id=${orden.id_orden}&cal=1`,
                                        }"
                                        class="action-buttons"
                                    >
                                        <div
                                            class="dias__visita"
                                            :style="`background-color:${getColor(
                                                orden
                                            )}`"
                                            :key="index2"
                                            @click=""
                                        >
                                            <div
                                                style="
                                                    border-bottom: 1px solid
                                                        rgb(216, 216, 216);
                                                    width: 100%;
                                                    text-align: center;
                                                    padding-bottom: 0.25rem;
                                                "
                                            >
                                                <div
                                                    style="
                                                        display: flex;
                                                        align-items: center;
                                                        justify-content: space-between;
                                                    "
                                                >
                                                    <div style="flex: 1">
                                                        <!-- <template
                                                            v-if="
                                                                elemento.orden_trabajo !=
                                                                null
                                                            "
                                                        > -->
                                                        <svg
                                                            v-if="
                                                                orden.instalacion_electrica ==
                                                                1
                                                            "
                                                            style="
                                                                width: 1.5rem;
                                                                height: 1.5rem;
                                                                color: white;
                                                            "
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            fill="none"
                                                            viewBox="0 0 24 24"
                                                            stroke-width="1.5"
                                                            stroke="currentColor"
                                                            class="w-6 h-6"
                                                        >
                                                            <path
                                                                stroke-linecap="round"
                                                                stroke-linejoin="round"
                                                                d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z"
                                                            />
                                                        </svg>
                                                        <!-- </template> -->
                                                    </div>

                                                    <div style="flex: 3">
                                                        {{ orden.nro_orden }}-
                                                        {{ elemento.horario }}
                                                    </div>

                                                    <div
                                                        style="
                                                            flex: 1;
                                                            display: flex;
                                                            align-items: center;
                                                        "
                                                        justify-content:end
                                                    >
                                                        <router-link
                                                            :to="`guardar-plan-orden?id=${orden.id}`"
                                                        >
                                                            <svg
                                                                v-if="
                                                                    elemento.id_estado ==
                                                                    1
                                                                "
                                                                style="
                                                                    width: 1.5rem;
                                                                    height: 1.5rem;
                                                                    color: white;
                                                                "
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                fill="none"
                                                                viewBox="0 0 24 24"
                                                                stroke-width="1.5"
                                                                stroke="currentColor"
                                                                class="w-6 h-6"
                                                            >
                                                                <path
                                                                    stroke-linecap="round"
                                                                    stroke-linejoin="round"
                                                                    d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
                                                                />
                                                            </svg>
                                                        </router-link>
                                                    </div>
                                                </div>
                                            </div>

                                            <div
                                                style="
                                                    border-bottom: 1px solid
                                                        rgb(216, 216, 216);
                                                    width: 100%;
                                                    text-align: center;
                                                    padding-bottom: 0.25rem;
                                                "
                                            >
                                                <div>
                                                    horas:
                                                    {{ orden.hora }}
                                                </div>
                                                <div v-if="orden.elevacion">
                                                    tiene elevación
                                                </div>
                                            </div>
                                            <template
                                                v-if="orden.presupuesto != null"
                                            >
                                                <template
                                                    v-if="
                                                        orden.presupuesto
                                                            .clientela != null
                                                    "
                                                >
                                                    <div>
                                                        {{
                                                            orden.presupuesto
                                                                .clientela
                                                                .nombre_comercial
                                                        }}
                                                    </div>
                                                    <div
                                                        v-if="
                                                            orden.presupuesto
                                                                .clientela
                                                                .direccion_instalacion !=
                                                            null
                                                        "
                                                    >
                                                        {{
                                                            orden.presupuesto
                                                                .clientela
                                                                .direccion_instalacion
                                                                .ciudad
                                                        }}
                                                    </div>
                                                    <div
                                                        v-else-if="
                                                            orden.presupuesto
                                                                .clientela
                                                                .dir != null
                                                        "
                                                    >
                                                        ({{
                                                            orden.presupuesto
                                                                .clientela.dir
                                                                .ciudad
                                                        }})
                                                    </div>
                                                </template>
                                            </template>
                                            <div v-else>
                                                Presupuesto eliminado
                                            </div>
                                            <div
                                                style="
                                                    border-top: 1px solid
                                                        rgb(216, 216, 216);
                                                    width: 100%;
                                                    text-align: center;
                                                    padding-bottom: 0.25rem;
                                                "
                                            >
                                                {{ elemento.observacion }}
                                            </div>
                                        </div>
                                    </router-link>
                                </template>
                            </template>

                            <!-- Forma antigua con la relacion de una sola orden -->
                            <!-- <router-link
                                    v-if="isElementoVisible(elemento, dia, equipo)"
                                    :to="{
                                        path: `/guardar-orden?id=${elemento.id_orden}`,
                                    }"
                                    class="action-buttons"
                                >
                                    <div
                                        class="dias__visita"
                                        :style="`background-color:${getColor(
                                            elemento
                                        )}`"
                                        :key="index"
                                        @click=""
                                    >
                                        <div
                                            style="
                                                border-bottom: 1px solid
                                                    rgb(216, 216, 216);
                                                width: 100%;
                                                text-align: center;
                                                padding-bottom: 0.25rem;
                                            "
                                        >
                                            <div
                                                style="
                                                    display: flex;
                                                    align-items: center;
                                                    justify-content: space-between;
                                                "
                                            >
                                                <div style="flex: 1">
                                                    <template
                                                        v-if="
                                                            elemento.orden_trabajo !=
                                                            null
                                                        "
                                                    >
                                                        <svg
                                                            v-if="
                                                                elemento
                                                                    .orden_trabajo
                                                                    .instalacion_electrica ==
                                                                1
                                                            "
                                                            style="
                                                                width: 1.5rem;
                                                                height: 1.5rem;
                                                                color: white;
                                                            "
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            fill="none"
                                                            viewBox="0 0 24 24"
                                                            stroke-width="1.5"
                                                            stroke="currentColor"
                                                            class="w-6 h-6"
                                                        >
                                                            <path
                                                                stroke-linecap="round"
                                                                stroke-linejoin="round"
                                                                d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z"
                                                            />
                                                        </svg>
                                                    </template>
                                                </div>

                                                <div
                                                    style="flex: 3"
                                                    v-if="
                                                        elemento.orden_trabajo !=
                                                        null
                                                    "
                                                >
                                                    {{
                                                        elemento.orden_trabajo
                                                            .nro_orden
                                                    }}-
                                                    {{ elemento.horario }}
                                                </div>

                                                <div
                                                    style="
                                                        flex: 1;
                                                        display: flex;
                                                        align-items: center;
                                                    "
                                                    justify-content:end
                                                >
                                                    <router-link
                                                        :to="`guardar-plan-orden?id=${elemento.id}`"
                                                    >
                                                        <svg
                                                            v-if="
                                                                elemento.id_estado ==
                                                                1
                                                            "
                                                            style="
                                                                width: 1.5rem;
                                                                height: 1.5rem;
                                                                color: white;
                                                            "
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            fill="none"
                                                            viewBox="0 0 24 24"
                                                            stroke-width="1.5"
                                                            stroke="currentColor"
                                                            class="w-6 h-6"
                                                        >
                                                            <path
                                                                stroke-linecap="round"
                                                                stroke-linejoin="round"
                                                                d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
                                                            />
                                                        </svg>
                                                    </router-link>
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            style="
                                                border-bottom: 1px solid
                                                    rgb(216, 216, 216);
                                                width: 100%;
                                                text-align: center;
                                                padding-bottom: 0.25rem;
                                            "
                                        >
                                            <div>
                                                horas:
                                                {{ elemento.orden_trabajo.hora }}
                                            </div>
                                            <div
                                                v-if="
                                                    elemento.orden_trabajo.elevacion
                                                "
                                            >
                                                tiene elevación
                                            </div>
                                        </div>
                                        <template
                                            v-if="
                                                elemento.orden_trabajo
                                                    .presupuesto != null
                                            "
                                        >
                                            <template
                                                v-if="
                                                    elemento.orden_trabajo
                                                        .presupuesto.clientela !=
                                                    null
                                                "
                                            >
                                                <div>
                                                    {{
                                                        elemento.orden_trabajo
                                                            .presupuesto.clientela
                                                            .nombre_comercial
                                                    }}
                                                </div>
                                                <div
                                                    v-if="
                                                        elemento.orden_trabajo
                                                            .presupuesto.clientela
                                                            .direccion_instalacion !=
                                                        null
                                                    "
                                                >
                                                    {{
                                                        elemento.orden_trabajo
                                                            .presupuesto.clientela
                                                            .direccion_instalacion
                                                            .ciudad
                                                    }}
                                                </div>
                                                <div
                                                    v-else-if="
                                                        elemento.orden_trabajo
                                                            .presupuesto.clientela
                                                            .dir != null
                                                    "
                                                >
                                                    ({{
                                                        elemento.orden_trabajo
                                                            .presupuesto.clientela
                                                            .dir.ciudad
                                                    }})
                                                </div>
                                            </template>
                                        </template>
                                        <div v-else>Presupuesto eliminado</div>
                                        <div
                                            style="
                                                border-top: 1px solid
                                                    rgb(216, 216, 216);
                                                width: 100%;
                                                text-align: center;
                                                padding-bottom: 0.25rem;
                                            "
                                        >
                                            {{ elemento.observacion }}
                                        </div>
                                    </div> 
                                </router-link> -->
                        </template>
                    </div>
                </template>
            </template>
        </div>
    </div>
</template>

<style>
.date-container {
    border-bottom: 1px solid rgb(216, 216, 216);
}
.time {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    min-height: 2rem;
}
.warning-icon {
    width: 1.5rem;
}
.amountButton-0 {
    min-width: none;
    display: flex;

    align-items: center;
    justify-content: center;
    border-radius: 1rem;
    background-color: #b4b4b4;
}
.dia {
    font-weight: bold;
    font-family: "Roboto", sans-serif !important;

    text-align: center;
    margin: 0.75rem;

    padding: 0.25rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.picker-header-arrow {
    color: gray;
    width: 2rem;
}
.picker-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 1rem;
}
.contnedor_calendario {
    border-radius: 0.5rem;
    margin-top: 1rem;
    border: 1px solid #dddddd;
}
.cita {
    display: flex;
    flex-direction: column;
}
.calendario {
    overflow-x: auto;
    width: 100%;
    display: grid !important;
}

.header {
    display: flex;
    justify-content: center;
    padding: 0.5rem;
}

.mes__titulo {
    text-align: center;
    padding: 0.5rem;
    color: #868ba1;
}
.titulo {
    display: flex;
    flex-direction: column;
}
.dias {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.dias__titulos,
.dias__fecha {
    padding: 0.5rem;
    background-color: #0866c6;
    color: white;
    text-align: center;
}

.dias__visita {
    flex-direction: column;
    min-width: none;
    display: flex;
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
    padding: 0.25rem;
    align-items: center;
    justify-content: center;
    border-radius: 1rem;
    background-color: #343434;
    color: white;
    min-width: 85%;
    min-height: 2rem;
}
</style>

<script>
import moment from "moment";

export default {
    props: ["value", "filter"],

    created() {
        this.currentDate.setDate(
            this.currentDate.getDate() - this.currentDate.getDay() + 1
        );

        this.handleResize();
        this.getequipos();
    },
    mounted() {
        this.handleResize(); // Check once on mount
        window.addEventListener("resize", this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize);
    },
    watch: {
        value: function (val) {
            //console.log("aja");
            // console.log("value", val);
        },
        num_dias: function (val) {
            //this.getWeek();
        },
    },
    filters: {
        hora_formated(val) {
            let str = val.toString().split(".");
            if (str.length > 1) {
                return str[0].toString().padStart(2, "0") + ":30";
            }
            return val.toString().padStart(2, "0") + ":00";
        },
    },
    computed: {
        rol: function () {
            return localStorage.getItem("role");
        },
    },
    methods: {
        isElementoVisible(elemento, dia, equipo) {
            // Verificar si la fecha coincide
            const fechaCoincide =
                elemento.fecha == dia.date ||
                (elemento.fecha_fin != null &&
                    elemento.fecha <= dia.date &&
                    elemento.fecha_fin >= dia.date);

            // Verificar si el equipo está asignado
            const equipoAsignado = elemento.equipo_ids.includes(equipo.id);

            // Verificar si tiene orden de trabajo
            // const tieneOrden = elemento.orden_trabajo != null;
            const tieneOrdenes = elemento.ordenes_trabajo != null;

            // Debug
            /*console.log("Visibility check:", {
                elemento: elemento.id,
                fecha: elemento.fecha,
                dia: dia.date,
                equipoId: equipo.id,
                equipoIds: elemento.equipo_ids,
                fechaCoincide,
                equipoAsignado,
                tieneOrden,
            });*/

            return fechaCoincide && equipoAsignado && tieneOrdenes;
        },
        handleResize() {
            const width = window.innerWidth;
            const mobileWidth = 768; // Define your mobile width breakpoint here

            if (width <= mobileWidth) {
                this.num_dias = 1;
            } else {
                this.currentDate.setDate(
                    this.currentDate.getDate() - this.currentDate.getDay() + 1
                );
                this.num_dias = 7;
            }
            this.getWeek();
        },
        getColor(item) {
            //console.log("Obtener color");
            //console.log(item);
            //343434 negro
            //verde 4caf50
            //fb8c00 naranja
            if (item.id_estado == 1) {
                return "#fb8c00";
            } else if (item.id_estado == 9) {
                return "#1987d2";
            } else {
                return "#4caf50";
            }
        },
        getequipos() {
            if (this.rol == 6 || this.rol == 7) {
                this.equipos = {
                    nombre: "",
                };
                return;
            }
            axios.get(`api/get-equipos`).then(
                (res) => {
                    this.equipos = res.data;
                },
                (err) => {
                    this.$custom_error("Error consultando los equipos");
                }
            );
        },

        calculateMes() {
            if (this.semana.length == 0) return "";
            return this.meses[
                parseInt((this.semana[0].date ?? "0-1-0").split("-")[1]) - 1
            ];
        },
        //BOTONES DE MOVER SEMANA
        nextWeek() {
            this.currentDate.setDate(
                this.currentDate.getDate() + this.num_dias
            );

            this.$emit(
                "referesh",
                moment(this.currentDate).format("YYYY-MM-DD"),
                moment(this.currentDate)
                    .add(this.num_dias, "days")
                    .format("YYYY-MM-DD"),
                this.filter
            );
            this.getWeek();
        },

        previousWeek() {
            this.currentDate.setDate(
                this.currentDate.getDate() - this.num_dias
            );
            this.$emit(
                "referesh",
                moment(this.currentDate).format("YYYY-MM-DD"),
                moment(this.currentDate)
                    .add(this.num_dias, "days")
                    .format("YYYY-MM-DD"),
                this.filter
            );
            this.getWeek();
        },

        //OBTENER SEMANA ACTUAL
        getWeek() {
            var week = new Array();
            let currentDate = new Date(this.currentDate);

            // Starting Monday not Sunday
            let finde = [];
            for (var i = 0; i < this.num_dias; i++) {
                const dia = new Date(currentDate).getDay();
                const fecha = new Date(currentDate).toISOString().split("T")[0];
                if (dia == 6 || dia == 7) {
                    finde.push({
                        label: dia,
                        date: fecha,
                    });
                }
                week.push({
                    label: dia,
                    date: fecha,
                });
                currentDate.setDate(currentDate.getDate() + 1);
            }
            if (this.num_dias == 7) {
                let found = false;
                finde.forEach((dia) => {
                    this.value.forEach((elemento) => {
                        if (
                            (elemento.fecha == dia.date ||
                                (elemento.fecha_fin != null &&
                                    elemento.fecha <= dia.date &&
                                    elemento.fecha_fin >= dia.date)) &&
                            elemento.orden_trabajo != null
                        ) {
                            found = true;
                        }
                    });
                });
                if (!found) {
                    this.show_dias = 5;
                    week.pop();
                    week.pop();
                } else {
                    this.show_dias = 7;
                }
            } else {
                this.show_dias = 1;
            }

            // console.log(this.semana);
            // console.log(new Date(this.currentDate).toISOString());
            this.semana = week;
            //console.log(week);
        },
    },

    data() {
        return {
            num_dias: 7,
            show_dias: 5,
            equipos: [],
            meses: [
                "Enero",
                "Febrero",
                "Marzo",
                "Abril",
                "Mayo",
                "Junio",
                "Julio",
                "Agosto",
                "Septiembre",
                "Octubre",
                "Noviembre",
                "Diciembre",
            ],
            semana: [],
            dias: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa", "Do"],
            currentDate: new Date(),
            mes: "",
        };
    },
};
</script>
